import { render, staticRenderFns } from "./AppItemInbox.vue?vue&type=template&id=4be3da78&"
import script from "./AppItemInbox.vue?vue&type=script&lang=js&"
export * from "./AppItemInbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports